import { Box, Container, Grid, Typography, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import Logo from "../../assets/logos/onurbpass_mark.png";

export default function Footer() {
  return (
    <Box
      sx={{
        mt: 4,
        pt: 4,
        pb: 3,
        borderTop: "1px solid var(--linha)",
        background: "rgba(8,22,43,0.86)",
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          maxWidth: "1120px",
          px: { xs: 2, sm: 2.5 },
        }}
      >
        {/* ENTERPRISE GRID */}
        <Box
          sx={{
            p: 2.5,
            borderRadius: "22px",
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
          }}
        >
          <Grid container spacing={3}>
            {/* BRAND / DESCRIPTION */}
            <Grid item xs={12} md={5}>
              <Stack spacing={1.5}>
                <Stack direction="row" spacing={1.5} alignItems="center">
                  <Box
                    component="img"
                    src={Logo}
                    alt="ONURB Pass"
                    sx={{
                      height: 34,
                      filter: "drop-shadow(0 10px 22px rgba(0,0,0,0.35))",
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: 900,
                      letterSpacing: "0.08em",
                      fontSize: 12,
                      opacity: 0.92,
                    }}
                  >
                    ONURB PASS
                  </Typography>
                </Stack>

                <Typography
                  sx={{
                    opacity: 0.78,
                    fontWeight: 700,
                    lineHeight: 1.5,
                    fontSize: 14,
                  }}
                >
                  Plataforma de venda de ingressos com checkout transparente e
                  experiência de compra profissional.
                </Typography>

                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {["PIX", "Crédito", "Débito"].map((item) => (
                    <Box
                      key={item}
                      sx={{
                        px: 1.2,
                        py: 0.6,
                        borderRadius: "999px",
                        background: "rgba(18,212,122,0.14)",
                        border: "1px solid rgba(18,212,122,0.22)",
                        fontWeight: 800,
                        fontSize: 12,
                      }}
                    >
                      {item}
                    </Box>
                  ))}
                </Stack>
              </Stack>
            </Grid>

            {/* ORGANIZADORES */}
            <Grid item xs={12} md={3}>
              <Typography
                sx={{
                  fontWeight: 900,
                  letterSpacing: "0.08em",
                  fontSize: 12,
                  opacity: 0.85,
                  mb: 1,
                }}
              >
                ORGANIZADORES
              </Typography>

              <Stack spacing={1}>
                <FooterLink to="/organizadores">Para organizadores</FooterLink>
                <FooterLink to="/como-funciona">Como funciona</FooterLink>
                <FooterLink to="/taxas">Taxas</FooterLink>
              </Stack>
            </Grid>

            {/* LEGAL */}
            <Grid item xs={12} md={3}>
              <Typography
                sx={{
                  fontWeight: 900,
                  letterSpacing: "0.08em",
                  fontSize: 12,
                  opacity: 0.85,
                  mb: 1,
                  textDecoration: "none",
                }}
              >
                LEGAL
              </Typography>

              <Stack spacing={1}>
                <FooterLink to="/termos">Termos de uso</FooterLink>
                <FooterLink to="/privacidade">
                  Política de privacidade
                </FooterLink>
                <FooterLink to="/meus-ingressos">Meus ingressos</FooterLink>
              </Stack>
            </Grid>
          </Grid>
        </Box>

        {/* BOTTOM */}
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: {md: "space-between", xs: "center"},
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            opacity: 0.75,
            fontWeight: 800,
            fontSize: 12,
          }}
        >
          <Box>
            © {new Date().getFullYear()} ONURB Pass • Todos os direitos
            reservados
          </Box>

          <Stack direction="row" spacing={1} alignItems="center">
            <FooterMiniLink to="/eventos">Eventos</FooterMiniLink>
            <span>•</span>
            <FooterMiniLink to="/organizadores">Organizadores</FooterMiniLink>
          </Stack>

          {/* DESENVOLVIDO POR: */}
          <Box sx={{ width: { xs: "100%", md: "auto" } }}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 0.6, sm: 0.8 }}
              alignItems={{ xs: "center", sm: "center" }}
              justifyContent={{ xs: "center", md: "flex-end" }}
              sx={{
                opacity: 0.92,
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: 12,
                  opacity: 0.9,
                  lineHeight: 1.1,
                }}
              >
                Desenvolvido por
              </Typography>

              <Typography
                component="a"
                href="https://www.e2tcode.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  fontWeight: 950,
                  letterSpacing: "0.02em",
                  color: "#fff",
                  textDecoration: "none",
                  opacity: 0.95,

                  // pill menor no mobile
                  px: { xs: 1.0, sm: 1.1 },
                  py: { xs: 0.28, sm: 0.35 },
                  borderRadius: "999px",

                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.12)",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.28)",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                  transition: "all .18s ease",

                  "&:visited": { color: "#fff" },
                  "&:hover": {
                    opacity: 1,
                    color: "#f4951f",
                    transform: "translateY(-1px)",
                    background: "rgba(230, 191, 142,0.10)",
                    border: "1px solid rgba(240, 172, 86,0.22)",
                    boxShadow: "0 18px 48px rgba(0,0,0,0.35)",
                  },
                }}
              >
                E2T Code
              </Typography>
            </Stack>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

/* =========================
   SUBCOMPONENTES
========================= */

function FooterLink({ to, children }) {
  return (
    <Typography
      component={RouterLink}
      to={to}
      sx={{
        fontWeight: 800,
        color: "#fff",
        opacity: 0.82,
        textDecoration: "none",
        "&:visited": {
          color: "#fff",
        },
        "&:hover": {
          opacity: 1,
          textDecoration: "underline",
        },
      }}
    >
      {children}
    </Typography>
  );
}

function FooterMiniLink({ to, children }) {
  return (
    <Typography
      component={RouterLink}
      to={to}
      sx={{
        fontWeight: 900,
        color: "#fff",
        opacity: 0.9,
        textDecoration: "none",
        "&:visited": {
          color: "#fff",
        },
        "&:hover": {
          textDecoration: "underline",
        },
      }}
    >
      {children}
    </Typography>
  );
}
